// Ưu đãi mua nhiều: giỏ từ 3 sản phẩm trở lên (cộng dồn số lượng, cùng hoặc khác loại)
// → mỗi sản phẩm giảm thêm 5% trên giá đang bán.
// Mirror của healthymall-be src/utils/promotion.js — backend tự tính lại khi tạo đơn, phải giữ cùng công thức.
export const BULK_MIN_QTY = 3;
export const BULK_RATE = 0.05;

/** Giá 1 sản phẩm trong giỏ: giá khuyến mãi (> 0) nếu có, không thì giá niêm yết — giống backend listPrice. */
export const unitPrice = (product) => (Number(product?.discountPrice) > 0 ? Number(product.discountPrice) : Number(product?.salePrice) || 0);

// Phí giao hàng (mirror backend): tiêu chuẩn 20K, MIỄN PHÍ khi tạm tính từ 499K; hỏa tốc 4H TP.HCM 50K.
export const SHIPPING_FEES = { standard: 20000, express: 50000 };
export const FREESHIP_MIN = 499000;
export const shippingFeeFor = (method, subtotal) =>
  method === "express" ? SHIPPING_FEES.express : (Number(subtotal) || 0) >= FREESHIP_MIN ? 0 : SHIPPING_FEES.standard;

/**
 * details: dòng đã qua bộ tính khuyến mãi (utils/promotionEngine.priceCartLocal(...).details) — giống backend:
 * quà (isGift) không tính; dòng giá mua kèm (noBulk) đếm vào "từ 3 sản phẩm" nhưng không giảm thêm 5%.
 */
export const bulkDiscount = (details) => {
  const items = (Array.isArray(details) ? details : []).filter((it) => !it?.isGift);
  const qty = items.reduce((s, it) => s + (Number(it?.quantity) || 0), 0);
  if (qty < BULK_MIN_QTY) return 0;
  // Làm tròn theo từng sản phẩm rồi nhân số lượng (giống backend)
  return items
    .filter((it) => !it?.noBulk)
    .reduce((s, it) => s + Math.round((Number(it?.discountPrice) || 0) * BULK_RATE) * (Number(it?.quantity) || 0), 0);
};
